import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';
import strings from 'strings';
import { FPCard, FPCardContent } from 'UI/components/atoms/FPCard';
import Text from 'UI/components/atoms/Text';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { useCardContentStyles } from 'UI/globalStyles/CardContent.styled';
import { SvgArrowDown, SvgArrowUp } from 'UI/res';

import { useStyles } from './styles';

/**
 * @typedef {Object} FooterActionsStateProps
 * @property {boolean} showMore
 * @property {boolean} isVisible
 */

const ITEM_TYPES = {
  list: 'list',
  table: 'table',
  custom: 'custom'
};

/**
 * @param {Object} props
 * @param {boolean} props.hasData
 * @param {React.ReactNode} props.content
 * @param {FooterActionsStateProps} props.footerActionsState
 * @param {boolean} props.hasRedirect
 * @param {boolean} props.isLoading
 * @param {boolean} props.isSmallViewPort
 * @param {Object} props.footerProps
 * @param {boolean} props.canBeExpanded
 */
const FPCardWrapper = ({
  hasData,
  canBeExpanded,
  content,
  footerActionsState,
  hasRedirect,
  isLoading,
  isSmallViewPort,
  contentConfig: { type, headerAction, hintText, title, subtitle, titleContent, withoutCardHeader },
  footerProps,
  headerProps
}) => {
  const cardClasses = useCardContentStyles();
  const classes = useStyles({ isSmallViewPort });

  const isTableTypeContent = type === ITEM_TYPES.table;

  const finalHeaderProps = !withoutCardHeader && {
    actionMode: headerAction ? 'actionAndExpand' : 'default',
    hintProps: hintText && {
      hint: hintText
    },
    title,
    subheader: subtitle,
    variant: 'hero',
    ...headerProps
  };

  const finalFooterProps =
    hasRedirect && footerActionsState.isVisible
      ? {
          footerActionIcon: footerActionsState.showMore ? SvgArrowUp : SvgArrowDown,
          customClass: !isTableTypeContent && classes.footerContainer,
          ...footerProps,
          CustomFooter: footerProps.CustomFooter
        }
      : { CustomFooter: footerProps.CustomFooter };

  const finalContent = isLoading ? (
    <div className={classes.loadingStateContainer}>
      <EmptyPlaceholder
        {...strings.shared.loading}
        customEmptyState={<CircularProgress className={classes.circularProgress} />}
      />
    </div>
  ) : (
    content
  );

  return (
    <FPCard>
      <FPCardContent
        canBeExpanded={canBeExpanded}
        className={clsx(
          !isTableTypeContent && classes.homeCard,
          isTableTypeContent && cardClasses.cardPaddingBottom
        )}
        headerProps={finalHeaderProps}
        footerProps={finalFooterProps}
      >
        {hasData && titleContent && (
          <Text className={classes.titleContentLabel} text={titleContent} />
        )}
        {finalContent}
      </FPCardContent>
    </FPCard>
  );
};

FPCardWrapper.defaultProps = {
  footerProps: {
    CustomFooter: null
  },
  canBeExpanded: true
};

export default FPCardWrapper;
